'use strict'
angular.module('mandaeApp')
  .directive('smartBanner', [function() {

    function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split('&');
      for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
          return sParameterName[1];
        }
      }
    }

    sbjs.init();

    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var i = 0;
        var interval = setInterval(function() {
          if (i == 3) {
            clearInterval(interval);

            if (document.location.pathname.indexOf('rastreamento') == -1) {

              // Inicialização do SmartBanner
              new SmartBanner({
                daysHidden: 15, // days to hide banner after close button is clicked (defaults to 15)
                daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
                appStoreLanguage: 'pt', // language code for the App Store (defaults to us)
                title: 'Mandaê',
                author: 'Mandaê',
                button: 'Ver',
                store: {
                  ios: 'OBTER - Na App Store',
                  android: 'OBTER - Na Google Play'
                },
                price: {
                  ios: 'Grátis',
                  android: 'Grátis'
                },
                utms: dataUtms
                  //,force: 'ios' // Uncomment for platform emulation
              });

              var banner = element.find('.smartbanner') ? element.find('.smartbanner') : [];

              element.find('.smartbanner-close, .smartbanner-button').on('click', function() {
                element.css('padding-top', '0');
                angular.element('.header-page').css({
                  'position': 'fixed',
                  'top': '0'
                });
              });

              if (banner.length !== 0) {
                element.css('padding-top', '84px');
                element.addClass('smart');
              };
            }
          }
          i += 1;
        }, 50);
      }
    }
  }]);
